<template>       
    <nav class="menu" id="menu">
        <div class="menu__heading">Meny</div>
        <ul class="menu__items">
            <li v-for="(item, index) in menuItems"
                v-bind:key="index">
                <a
                    v-bind:class="cssItemClass(item)"
                    v-on:click.prevent="open(item)"
                    class="menu__item">
                    <span>{{ item.title }}</span>
                    <svg v-if="item.items"
                        class="icon icon-more" width="12px" height="8px">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-more"></use>
                    </svg>
                </a>
                 <transition name="menu__items--slide">
                    <ul v-if="item.items && item.expanded"
                        v-bind:class="cssChildItemClass(item)">
                        <li v-for="(subitem, index) in item.items"
                            v-bind:key="index">
                            <router-link 
                                :to="{ name: 'page', params: { slug: subitem.slug, parent : subitem.parent.slug }}" 
                                active-class="menu__item--active" exact 
                                v-on:click.native="$emit('close')"
                                class="menu__item">
                                <span>{{ subitem.title }}</span>
                            </router-link>
                        </li>
                    </ul>
                 </transition>
            </li>
            <li v-if="favorites.length"
                v-on:click.prevent="expandedFavorites = !expandedFavorites">
                <span 
                    v-bind:class="{ 'menu__item--expanded' : expandedFavorites }"
                    class="menu__item bg-color-grey2">
                    <span>Favoritter</span>
                    <svg class="icon icon-more" width="12px" height="8px">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-more"></use>
                    </svg>
                </span>
                <transition name="menu__items--slide">
                    <ul v-if="expandedFavorites" class="bg2-color-grey2">
                        <li v-for="(favorite, index) in favorites"
                            v-bind:key="index">
                            <router-link 
                                :to="{ name: 'page', params: { slug: favorite.slug, parent : favorite.parentSlug ? favorite.parentSlug : null }}" 
                                v-on:click.native="$emit('close')"
                                class="menu__item">
                                <span>{{ favorite.title }}</span>
                            </router-link>
                        </li>
                    </ul>
                </transition>
            </li>
        </ul>
    </nav>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'Menu',
        computed: mapState([
            'ready',
            'menuItems',
            'page',
            'favorites'
        ]),
        data: function () {
            return {
                expandedFavorites: false,
            }
        },
        created() {
            this.loadMenu().then(
                () => {
                    this.setActivePage();
                }
            );
        },
        /*watch: {
            slug: function (slug) {
                this.setActivePage();
            },
        },*/
        methods: {
            ...mapActions([
                'loadMenu']),
            cssItemClass(item) {
                let classes = { 'menu__item--expanded': item.expanded };
                if(item.color) {
                    classes['bg-color-' + item.color] = true;
                }
                return classes;
            },
            cssChildItemClass(item) {
                let classes = {};
                if(item.color) {
                    classes['bg2-color-' + item.color] = true;
                }
                return classes;
            },
            open(item) {
                if(item.items) {
                    item.expanded = !item.expanded;
                }
                return false;
            },
            setActivePage() {
                if(this.page && this.menuItems.length) {
                    const page = this.page;
                    for(const item of this.menuItems) {
                        if(item.items) {
                            for(const subitem of item.items) {
                                if(subitem.id == page.id) {
                                    item.expanded = true;
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }
    };
</script>

<style lang="scss">
    .menu {
        min-height: 100vh;

        color:#333;
        background: #9c9c9c;
        box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.3);

        a {
            color:#fff;
        }

        &__heading {
            //height:32px;
            padding:9px 16px 10px 16px;
            border-bottom:1px solid #fff;
            background-color: #dca83f;
        }

        ul {
            margin:0;
            padding:0;
            list-style-type: none;
            background-color: #fff;

            li {
                border-bottom:1px solid #fff;

                .menu__item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding:14px 24px 14px 16px;

                    cursor:pointer;

                    svg {
                        transform: rotate(-90deg);
                        transition:transform 0.5s;
                    }

                    &--expanded {
                        svg {
                            
                            transform: rotate(0deg);
                        }
                    }

                }

                &:last-child {
                    border-bottom:0;
                }

                ul {
                    height:auto;
                    overflow:hidden;

                    padding-top: 3px;
                    padding-bottom: 10px;

                    li {
                        border-bottom-width:0;

                        .menu__item {
                            padding:6px 18px;
                            color:#000;

                            &--active {
                                font-weight: 400;
                            }
                        }                        
                    }
                }
            }
        }

        .menu__items {
            &--slide-enter-active {
                transition:max-height 0.5s ease-out;
            }
            &--slide-enter {
                max-height: 0;
            }    
            &--slide-enter-to {
                max-height: 600px;
            }

            &--slide-leave-active {
                transition:max-height 0.2s ease-out;
            }
            &--slide-leave {
                max-height: 600px;
            }    
            &--slide-leave-to {
                max-height: 0;
            }
        }
    }
</style>
